import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { getActiveSchoolLicense } from '../../store/reducers';
import { getPlanByLicense } from 'Settings/pricing-options';

class SubscriptionPlanInfo extends React.PureComponent {
  render() {
    const { plan, license, render } = this.props;
    if (!plan || !license) return null;
    return render({
      plan,
      license,
    });
  }
}

SubscriptionPlanInfo.propTypes = {
  plan: PropTypes.object,
  license: PropTypes.object,
  render: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const licenses = getActiveSchoolLicense(state);
  if (!licenses || licenses.length === 0) return {};
  return {
    license: licenses[0],
    plan: getPlanByLicense(licenses[0].license_type),
  };
};

export default connect(mapStateToProps, {})(SubscriptionPlanInfo);
